var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { DialogActions, Typography, Button } from "@mui/material";
import theme from '../theme';
import { ThemeProvider } from "@mui/material/styles";
import { isFunction } from "lodash";
function DefaultConfirm(props) {
    return props.confirm({
        title: (_jsx("div", __assign({ style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }, { children: _jsx(Typography, __assign({ sx: {
                    font: 'normal normal bold 16px/24px Lato',
                    letterSpacing: '0.32px',
                    color: '#1C1E33'
                } }, { children: props.title ? props.title : "Are you sure?" })) }))),
        description: props.components.description,
        confirmationText: props.confirmationText,
        confirmationButtonProps: {
            //@ts-ignore
            sx: {
                border: '1px solid #FF4545',
                color: '#FF4545',
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                boxShadow: '0px 2px 2px #00000029',
                borderRadius: '6px',
                autoFocus: true
            }
        },
        cancellationButtonProps: {
            //@ts-ignore
            sx: {
                color: '#999999',
                textAlign: 'left',
                font: 'normal normal medium 16px/24px Lato',
                letterSpacing: '0.32px',
            }
        },
    });
}
var Delete = function (props) {
    var _a = useState(false), deleting = _a[0], setDeleting = _a[1];
    useEffect(function () {
        props.setDeleting && props.setDeleting(deleting);
    }, [deleting]);
    return (_jsxs(ThemeProvider, __assign({ theme: theme }, { children: [!deleting &&
                _jsxs(Button, __assign({ sx: { color: "red" }, size: "large", onClick: function () { return setDeleting(true); } }, { children: [props.label ? isFunction(props.label) ? props.label(props) : props.label : "Delete", " "] })), deleting &&
                _jsxs(DialogActions, __assign({ disableSpacing: true, sx: { justifyContent: "flex-start", marginBottom: 0, padding: 0 } }, { children: [_jsx(Typography, __assign({ sx: { fontWeight: '500', marginRight: '20px' } }, { children: "Are you sure?" })), _jsx(Button, __assign({ variant: "outlined", size: "small", sx: { marginRight: '10px' }, color: "error", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            setDeleting(false);
                                            return [4 /*yield*/, props.actions.onSubmit()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: "Yes" })), _jsx(Button, __assign({ variant: "outlined", size: "small", onClick: function () { return setDeleting(false); } }, { children: "No" }))] }))] })));
};
export { Delete, DefaultConfirm };
